module.exports = __webpack_public_path__ + "c2933eed457c7009dec876083596188a.svg";